// extracted by mini-css-extract-plugin
module.exports = {"logosWrapper":"PaymentLogos_logosWrapper__a9Dj7","left":"PaymentLogos_left__QYVGN","right":"PaymentLogos_right__myP01"};